exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tag {\n  background-color: #f4ab34;\n  font-size: 1.2rem;\n  color: #333;\n  border-radius: 1.2rem;\n  padding: 4px 6px;\n  font-weight: normal;\n  margin-left: 1.6rem;\n}\n", ""]);
